"use strict";
const _ = require("lodash");

export default angular
  .module("LinkCtrl", ["angularUtils.directives.dirPagination", "ui.bootstrap"])
  .controller("LinkController", [
    "$scope",
    "$http",
    "$modal",
    "$filter",
    "$rootScope",
    // "Socket",
    "Flash",
    "Links",
    function(
      $scope,
      $http,
      $modal,
      $filter,
      $rootScope,
      // Socket,
      Flash,
      Links
    ) {
      $scope.search = {
        code: "",
        codesystem: ""
      };

      const loadLinks = function() {
        $scope.loadingLinks = true;
        Links.loadLinksFromDatabase(function(data) {
          console.log('🚀 ~ Links.loadLinksFromDatabase ~ data:', data)
          $scope.links.data = data;
          $scope.selected.link = "";
          $scope.loadingLinks = false;
        }, $scope.search);
      };

      Links.getCodesystems(function(data) {
        $scope.codeSystems = data;
      });

      $scope.loadLinks = loadLinks;
      $scope.loadingLinks = false;

      $scope.links = {
        data: []
      };
      $scope.searchFilterString = "";
      loadLinks();

      $scope.currentPage = 1;
      $scope.tablePage = {
        size: { value: 10, name: "10" },
        options: [
          { value: 10, name: "10" },
          { value: 50, name: "50" },
          { value: $scope.links.data.length, name: "Kaikki" }
        ]
      };
      $scope.sortLinks = {
        column: "ID",
        descending: false
      };
      $scope.selected = {};
      $scope.selectedLanguage = "EN";
      $scope.$watch(
        function() {
          return $rootScope.selectedLanguage;
        },
        function() {
          $scope.selectedLanguage = $rootScope.selectedLanguage;
        },
        true
      );

      // Sets table sort according to COLUMN, toggles between ascending and descending
      $scope.changeSorting = function(column) {
        if ($scope.sortLinks.column == column) {
          $scope.sortLinks.descending = !$scope.sortLinks.descending;
        } else {
          $scope.sortLinks.column = column;
          $scope.sortLinks.descending = false;
        }
      };

      $scope.selectLink = function(link) {
        $scope.selected.link = link;
      };

      $scope.getIcon = function(column) {
        if ($scope.sortLinks.column == column) {
          if ($scope.sortLinks.descending) {
            return "glyphicon-triangle-bottom";
          } else {
            return "glyphicon-triangle-top";
          }
        }
      };

      // Returns true if no selected link; used for disabling buttons
      $scope.checkSelectedEmpty = function() {
        return !$scope.selected.link;
      };

      $scope.openAddNewLinkModal = function() {
        var aliases = [];
        Links.loadAliasesFromDatabase(function(status, success) {
          if (success) {
            console.log("Loaded aliases with status: " + status);
            aliases = Links.getAliases();
            var modalInstance = $modal.open({
              animation: true,
              backdrop: "static",
              templateUrl: "view/modal/add-link-modal.html",
              size: "lg",
              controller: "NewLinkController",
              resolve: {
                aliases: function() {
                  return aliases;
                }
              }
            });
            modalInstance.result.then(function(newLink) {
              if (newLink.ALIAS_1_ANY === 0) {
                newLink.ALIAS_1_ID = newLink.ALIAS_1.originalObject.SYS_ID;
              } else if (
                newLink.ALIAS_1_ANY === -1 ||
                newLink.ALIAS_1_ANY === -2
              ) {
                newLink.ALIAS_1_ID = newLink.ALIAS_1_ANY;
              }
              newLink.ALIAS_2_ID = newLink.ALIAS_2.originalObject.SYS_ID;
              Links.postNewLink(newLink, function(status, success, data) {
                if (success) {
                  Flash.create("success",
                    $filter("translate")("SUCCESS_NEW_LINK_TEXT") + data.ID,
                    $filter("translate")("SUCCESS_NEW_LINK_TITLE")
                  );
                  console.log(
                    "POST: api/link/ responded with status: " + status
                  );
                  // Socket.emit("send:message", {
                  //   message: "New linkage ID: " + data.ID + " added.",
                  //   user: $rootScope.loggedUser.fullname
                  // });
                 loadLinks();
                }
              });
            });
          }
        });
      };

      $scope.openEditLinkModal = function(link) {
        console.log('🚀 ~ link:', link)
        var aliases = [];
        Links.loadAliasesFromDatabase(function(status, success) {
          if (success) {
            console.log("Loaded aliases with status: " + status);
            aliases = Links.getAliases();
            link.oldAlias1 = {};
            link.oldAlias2 = _.find(aliases, _.matches({ SYS_ID: parseInt(link.ALIAS_2_ID) }));
            console.log('🚀 ~ Links.loadAliasesFromDatabase ~ oldAlias2:', link.oldAlias2)

            link.oldAliasAny = 0;
            console.log('🚀 ~ Links.loadAliasesFromDatabase ~ parseInt(link.ALIAS_1_ID):', link.ALIAS_1_ID)
            if (
              parseInt(link.ALIAS_1_ID) != -1 &&
              parseInt(link.ALIAS_1_ID) != -2
            ) {
              link.oldAlias1 = _.find(aliases, _.matches({ SYS_ID: parseInt(link.ALIAS_1_ID) }));

            } else {
              link.oldAliasAny = link.ALIAS_1_ID;
            }
            var modalInstance = $modal.open({
              animation: true,
              backdrop: "static",
              templateUrl: "view/modal/link-details-modal.html",
              size: "lg",
              controller: "EditLinkController",
              resolve: {
                aliases: function() {
                  return aliases;
                },
                oldLink: function() {
                  return link;
                }
              }
            });
            modalInstance.result.then(function(newLink) {
              if (newLink.ALIAS_1_ANY === 0) {
                newLink.ALIAS_1_ID = newLink.ALIAS_1.originalObject.SYS_ID;
              } else if (
                newLink.ALIAS_1_ANY === -1 ||
                newLink.ALIAS_1_ANY === -2
              ) {
                newLink.ALIAS_1_ID = newLink.ALIAS_1_ANY;
              }
              newLink.ALIAS_2_ID = newLink.ALIAS_2.originalObject.SYS_ID;
              // Change decimal point to dot
              Links.saveModifiedLink(newLink, function(status, success) {
                if (success) {
                  Flash.create("success",
                    $filter("translate")("SUCCESS_EDIT_LINK_TEXT") + newLink.ID,
                    $filter("translate")("SUCCESS_EDIT_LINK_TITLE")
                  );
                  console.log(
                    "PUT: api/link/ responded with status: " + status
                  );
                  // Socket.emit("send:message", {
                  //   message: "Linkage ID: " + newLink.ID + " edited.",
                  //   user: $rootScope.loggedUser.fullname
                  // });
                  loadLinks();
                } else {
                  Flash.create("warning",
                    $filter("translate")("FAILED_EDIT_LINK_TEXT"),
                    "Error"
                  );
                }
              });
            });
          }
        });
            console.log('🚀 ~ Links.loadAliasesFromDatabase ~ _:', _)
      };

      $scope.openDeleteLinkModal = function(link) {
        var modalInstance = $modal.open({
          animation: true,
          backdrop: "static",
          templateUrl: "view/modal/delete-link-modal.html",
          size: "md",
          controller: function($scope, $modalInstance, Flash, link) {
            $scope.link = link;
            $scope.ok = function() {
              $modalInstance.close(link);
            };
            $scope.cancel = function() {
              $modalInstance.dismiss("cancel");
            };
          },
          resolve: {
            link: function() {
              return link;
            }
          }
        });
        modalInstance.result.then(function(link) {
          Links.deleteLink(link.ID, function(status, success) {
            if (success) {
              Flash.create("success",
                $filter("translate")("SUCCESS_DEL_LINK_TEXT") + link.ID,
                $filter("translate")("SUCCESS_DEL_LINK_TITLE")
              );
              console.log("DELETE: api/link/ responded with status: " + status);
              // Socket.emit("send:message", {
              //   message: "Linkage ID: " + link.ID + " deleted.",
              //   user: $rootScope.loggedUser.fullname
              // });
              loadLinks();
            } else {
              Flash.create("warning",
                $filter("translate")("FAILED_DEL_LINK_TEXT") + status,
                "Error"
              );
            }
          });
        });
      };
    }
  ]);
